export default __webpack_public_path__ + "static/media/FinosecAcademy.a0e0ece6.jpg";